/**
 * Floating Buttons — Tools & Enquire Now
 *
 * - Content (iframes / shortcode HTML) is loaded lazily on first open.
 * - Tabs switch without re-fetching already-loaded panes.
 * - Overlay click and Escape key close the modal.
 */
(function () {
	'use strict';

	var overlay, modal, closeBtn, tabsNav, modalTitle, modalIconTools, modalIconEnquire;
	var loadedPanes = {}; // track which panes have been lazy-loaded
	var closeFallbackTimer = null;

	function init() {
		overlay   = document.getElementById('ca-fb-overlay');
		modal     = document.getElementById('ca-fb-modal');
		closeBtn  = document.getElementById('ca-fb-close');
		tabsNav    = document.getElementById('ca-fb-tabs-nav');
		modalTitle = document.getElementById('ca-fb-modal-title');
		modalIconTools = document.getElementById('ca-fb-modal-icon-tools');
		modalIconEnquire = document.getElementById('ca-fb-modal-icon-enquire');

		if (!overlay || !modal) return;

		// Floating button triggers
		document.querySelectorAll('[data-ca-fb-open]').forEach(function (btn) {
			btn.addEventListener('click', function () {
				openModal(btn.dataset.caFbOpen);
			});
		});

		// Tab clicks
		if (tabsNav) {
			tabsNav.addEventListener('click', function (e) {
				var btn = e.target.closest('[data-ca-fb-tab]');
				if (!btn) return;
				activateTab(btn.dataset.caFbTab);
			});
		}

		// Close triggers
		closeBtn.addEventListener('click', closeModal);
		overlay.addEventListener('click', closeModal);
		document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape') closeModal();
		});
	}

	/* ── Open / Close ───────────────────────────────────────────── */

	function openModal(mode) {
		// Show/hide the tabs nav depending on mode
		var toolsPanel   = document.getElementById('ca-fb-tools-panel');
		var enquirePanel = document.getElementById('ca-fb-enquire-panel');

		if (mode === 'tools') {
			modalTitle.textContent = caFbData.toolsTitle || 'Immigration Tools';
			if (modalIconTools) modalIconTools.hidden = false;
			if (modalIconEnquire) modalIconEnquire.hidden = true;
			if (tabsNav)     tabsNav.style.display = '';
			if (toolsPanel)  { toolsPanel.style.display = ''; activateFirstTab(); }
			if (enquirePanel) enquirePanel.style.display = 'none';
		} else {
			modalTitle.textContent = caFbData.enquireTitle || 'Enquire Now';
			if (modalIconTools) modalIconTools.hidden = true;
			if (modalIconEnquire) modalIconEnquire.hidden = false;
			if (tabsNav)     tabsNav.style.display = 'none';
			if (toolsPanel)  toolsPanel.style.display = 'none';
			if (enquirePanel) {
				enquirePanel.style.display = '';
				lazyLoadEnquire(enquirePanel);
			}
		}

		// Animate in
		overlay.classList.add('is-open');
		modal.classList.add('is-open');
		document.body.classList.add('ca-fb-no-scroll');

		requestAnimationFrame(function () {
			overlay.classList.add('is-visible');
			modal.classList.add('is-visible');
		});

		closeBtn.focus();
	}

	function finishCloseModal() {
		overlay.classList.remove('is-open');
		modal.classList.remove('is-open');
		document.body.classList.remove('ca-fb-no-scroll');
	}

	function closeModal() {
		if (closeFallbackTimer) {
			window.clearTimeout(closeFallbackTimer);
			closeFallbackTimer = null;
		}

		overlay.classList.remove('is-visible');
		modal.classList.remove('is-visible');

		var onOverlayTransitionEnd = function (e) {
			if (e.target !== overlay || e.propertyName !== 'opacity') {
				return;
			}
			overlay.removeEventListener('transitionend', onOverlayTransitionEnd);
			if (closeFallbackTimer) {
				window.clearTimeout(closeFallbackTimer);
				closeFallbackTimer = null;
			}
			finishCloseModal();
		};

		overlay.addEventListener('transitionend', onOverlayTransitionEnd);

		// Fallback when transitionend does not fire (e.g. quick open+close race).
		closeFallbackTimer = window.setTimeout(function () {
			overlay.removeEventListener('transitionend', onOverlayTransitionEnd);
			closeFallbackTimer = null;
			finishCloseModal();
		}, 400);
	}

	/* ── Tab Logic ──────────────────────────────────────────────── */

	function activateFirstTab() {
		var firstBtn = tabsNav && tabsNav.querySelector('[data-ca-fb-tab]');
		if (firstBtn && !tabsNav.querySelector('.is-active')) {
			activateTab(firstBtn.dataset.caFbTab);
		}
	}

	function activateTab(tabId) {
		// Update tab button state
		tabsNav.querySelectorAll('[data-ca-fb-tab]').forEach(function (btn) {
			btn.classList.toggle('is-active', btn.dataset.caFbTab === tabId);
		});

		// Update pane visibility
		document.querySelectorAll('[data-ca-fb-pane]').forEach(function (pane) {
			var active = pane.dataset.caFbPane === tabId;
			pane.classList.toggle('is-active', active);
			if (active) lazyLoadPane(pane, tabId);
		});
	}

	/* ── Lazy Loading ───────────────────────────────────────────── */

	function lazyLoadPane(pane, tabId) {
		if (loadedPanes[tabId]) return; // already loaded
		loadedPanes[tabId] = true;
		fetchPaneContent({ mode: 'tools', tab: tabId })
			.then(function (payload) {
				renderPanePayload(pane, payload);
			})
			.catch(function () {
				loadedPanes[tabId] = false;
				buildError(pane);
			});
	}

	function lazyLoadEnquire(panel) {
		if (loadedPanes['__enquire__']) return;
		loadedPanes['__enquire__'] = true;
		fetchPaneContent({ mode: 'enquire' })
			.then(function (payload) {
				renderPanePayload(panel, payload);
			})
			.catch(function () {
				loadedPanes['__enquire__'] = false;
				buildError(panel);
			});
	}

	function renderPanePayload(container, payload) {
		if (!payload || !payload.type) {
			buildError(container);
			return;
		}

		if (payload.type === 'iframe') {
			buildIframe(container, payload.content || '');
			return;
		}

		buildHtml(container, payload.content || '');
	}

	function fetchPaneContent(params) {
		var ajaxUrl = (window.canadaAbroad && window.canadaAbroad.ajaxUrl) || '/wp-admin/admin-ajax.php';
		var body = new URLSearchParams();
		body.append('action', (window.caFbData && window.caFbData.ajaxAction) || 'ca_fb_get_content');
		body.append('nonce', (window.caFbData && window.caFbData.ajaxNonce) || '');
		body.append('mode', params.mode);
		if (params.tab) {
			body.append('tab', params.tab);
		}

		return window.fetch(ajaxUrl, {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
			credentials: 'same-origin',
			body: body.toString()
		})
			.then(function (res) { return res.json(); })
			.then(function (json) {
				if (!json || !json.success || !json.data) {
					throw new Error('Content fetch failed');
				}
				return json.data;
			});
	}

	function buildIframe(container, url) {
		// Show loader
		var loader = document.createElement('div');
		loader.className = 'ca-fb-loader';
		container.appendChild(loader);

		var iframe = document.createElement('iframe');
		iframe.className   = 'ca-fb-iframe';
		iframe.src         = url;
		iframe.allow       = 'fullscreen';
		iframe.loading     = 'lazy';
		iframe.style.opacity = '0';
		iframe.style.transition = 'opacity 0.3s ease';

		iframe.addEventListener('load', function () {
			loader.remove();
			iframe.style.opacity = '1';
		});

		container.appendChild(iframe);
	}

	function buildHtml(container, html) {
		container.classList.add('ca-fb-pane--content');
		container.innerHTML = html;

		// Re-run any inline scripts embedded in the shortcode output
		container.querySelectorAll('script').forEach(function (oldScript) {
			var s = document.createElement('script');
			s.textContent = oldScript.textContent;
			oldScript.parentNode.replaceChild(s, oldScript);
		});

		// Re-initialize dynamic tables injected after DOMContentLoaded
		if (window.CA_DynamicTable && typeof window.CA_DynamicTable.init === 'function') {
			window.CA_DynamicTable.init();
		}

		// Searchable selects (.js-form-select-search) only bind on init; required after lazy HTML inject.
		if (typeof window.canadaAbroadInitFormSelectSearch === 'function') {
			window.canadaAbroadInitFormSelectSearch(container);
		}
	}

	function buildError(container) {
		container.classList.add('ca-fb-pane--content');
		container.innerHTML = '<div class="ca-fb-error">Unable to load content. Please try again.</div>';
	}

	/* ── Boot ───────────────────────────────────────────────────── */

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
